<div
  *ngFor="let voucher of (sortedVouchers?.length > 0 ? sortedVouchers : notValidCouponsError.errorVouchers)"
  class="voucher-display udex-mt-8"
>
  <ui5-icon
    class="voucher-display__icon"
    [design]="!notValidCouponsError.isError ? 'Positive' : 'Critical'"
    [name]="!notValidCouponsError.isError ? 'sap-icon://accept' : 'sap-icon://warning'"
  ></ui5-icon>
  <span *ngIf="!notValidCouponsError.isError" class="body--s voucher-display__code">{{ voucher.voucherCode }}</span>
  <span
    *ngIf="notValidCouponsError.isError"
    class="body--s voucher-display__code invalid"
  >{{ ('voucher.errors.voucherNoLongerValid' | cxTranslate : {voucherCode: voucher.voucherCode}) }}</span>
  <ng-container *ngIf="!isReadOnly">
    <udex-button
      *ngIf="!removeCoupon; else showSpinner"
      class="voucher-display__button"
      (click)="removeVoucher(voucher.voucherCode)"
      design="Tertiary"
      icon="sap-icon://delete"
      [accessibleName]="'common.close' | cxTranslate"
      [disabled]="cartIsLoading"
      type="Button"
    >{{ "cartDetails.remove" | cxTranslate }}
    </udex-button>
    <ng-template #showSpinner>
      <udex-button
        class="voucher-display__button"
        size="Large"
        design="Secondary"
        [disabled]="cartIsLoading"
      >
        <ui5-busy-indicator
          size="Medium"
          class="d-flex"
          active></ui5-busy-indicator>
      </udex-button>
    </ng-template>
  </ng-container>


</div>
